var map = {
	"./arbitrum": 419,
	"./arbitrum.json": 419,
	"./aurora": 420,
	"./aurora.json": 420,
	"./avax": 421,
	"./avax.json": 421,
	"./bsc": 422,
	"./bsc.json": 422,
	"./celo": 423,
	"./celo.json": 423,
	"./cronos": 424,
	"./cronos.json": 424,
	"./emerald": 425,
	"./emerald.json": 425,
	"./ethereum": 426,
	"./ethereum.json": 426,
	"./fantom": 427,
	"./fantom.json": 427,
	"./fuse": 428,
	"./fuse.json": 428,
	"./harmony": 429,
	"./harmony.json": 429,
	"./heco": 430,
	"./heco.json": 430,
	"./kava": 431,
	"./kava.json": 431,
	"./metis": 432,
	"./metis.json": 432,
	"./moonbeam": 433,
	"./moonbeam.json": 433,
	"./moonriver": 434,
	"./moonriver.json": 434,
	"./optimism": 435,
	"./optimism.json": 435,
	"./partners": 322,
	"./partners.json": 322,
	"./polygon": 436,
	"./polygon.json": 436
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 689;